/** 개정 고지(`W-90`)를 이 브라우저에서 **자동으로 한 번 띄웠는가**의 표시(PRD `7.5.17` 요건 ⑤).
 *
 * 열쇠는 개정의 `id`(판 문자열)다. 다른 개정이 오면 다시 한 번 뜬다. 다시 여는 줄(`W-70`)은 이 표시와 상관없이
 * 시행일까지 선다. **동의가 아니고, 서버로 보내지 않는다.** 셀러의 정보가 아니라 이 브라우저가 고지를 띄웠는지의
 * 표시라 로그아웃에도 지우지 않는다. 셀러를 가리키는 값이 없다(판 문자열과 「1」뿐).
 * 저장이 막힌 브라우저(사생활 보호 모드 등)에서는 매번 한 번씩 뜬다. 덜 뜨는 쪽보다 낫다. */

function keyOf(amendmentId: string): string {
  return `makit/policy-amendment-shown/${amendmentId}`;
}

export function wasAmendmentShown(amendmentId: string): boolean {
  try {
    return window.localStorage.getItem(keyOf(amendmentId)) !== null;
  } catch {
    return false;
  }
}

export function markAmendmentShown(amendmentId: string): void {
  try {
    window.localStorage.setItem(keyOf(amendmentId), "1");
  } catch {
    // 다음에 한 번 더 뜬다.
  }
}
